import React from 'react';
import { PrimaryButton } from '../button/Button';

export type UpgradeSubscriptionButtonProps = {
    link?: string;
    label?: string;
    onClick?: () => void;
    buttonClassName?: string;
};
const UpgradeSubscriptionButton = ({
    label,
    onClick,
    buttonClassName,
    link = 'https://www.naturemetrics.shop/collections/subscribe',
}: UpgradeSubscriptionButtonProps) => {
    return (
        <a rel='noreferrer' href={link} onClick={onClick} target='_blank'>
            <PrimaryButton className={buttonClassName}>{label || 'Subscribe to access'}</PrimaryButton>
        </a>
    );
};

export default UpgradeSubscriptionButton;
